import {
    RadialBarChart,
    RadialBar,
    Legend,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { useSelector } from "react-redux";
import { selectGlobalState } from "../../state-management/selectors";

const RadialBarCharts = () => {
    const { newsData, articlesData, projectsData, currentUserData } =
        useSelector(selectGlobalState);

    const getUserData = (data: any[]) =>
        data.filter((item) => item.created_by === currentUserData._id).length;

    const getOtherUserData = (data: any[]) =>
        data.filter((item) => item.created_by !== currentUserData._id).length;

    const getTotalData = (data: any[]) => data.length;

    const formatChartData = (data: any[]) => [
        { name: "شما", value: getUserData(data), fill: "#81c26e" },
        { name: "دیگران", value: getOtherUserData(data), fill: "#a0bd88" },
        { name: "کل", value: getTotalData(data), fill: "#2D667F" },
    ];

    const renderRadialBarChart = (data: any, title: string) => (
        <div
            style={{
                textAlign: "center",
                width: "100%",
            }}
        >
            <h3 style={{ fontSize: "16px", marginBottom: "10px" }}>{title}</h3>
            <ResponsiveContainer width="100%" height={200}>
                <RadialBarChart
                    innerRadius="40%"
                    outerRadius="90%"
                    barSize={15}
                    data={data}
                >
                    <RadialBar
                        dataKey="value"
                        background={{ fill: "transparent" }}
                    />
                    <Tooltip />
              
 <Legend
                        iconSize={8}
                        layout="horizontal"
                        verticalAlign="bottom"
                        align="center"
                        fontSize={8}
                    />
          
                
                </RadialBarChart>
            </ResponsiveContainer>
        </div>
    );

    return (
        <div className="flex items-center justify-center w-full h-full">
        <div className="grid grid-cols-3 gap-2 p-2 text-right md:text-center place-items-center w-full text-[11px]">
          {renderRadialBarChart(formatChartData(articlesData), "مقالات")}
          {renderRadialBarChart(formatChartData(projectsData), "پروژه‌ها")}
          {renderRadialBarChart(formatChartData(newsData), "اخبار")}
        </div>
      </div>
      
    );
};

export default RadialBarCharts;
